<template>
  <div class="pt-[15px] ">
    <Border radius="13px">
      <div class="conviteClass rounded-[13px]">
        <div>
          <div class="color-[#5FB589] text-[13px]">{{ $t('inviteCenter.myId') }}<span class="color-[#FEFFFE]">{{
            userInfo?.id }}</span></div>
          <div class="color-[#5FB589] text-[13px] mt-[20px]">{{ $t('inviteCenter.myInviterId') }}<span
              class="color-[#FEFFFE]">{{ tuiages?.superior }}</span></div>
          <div class="color-[#5FB589] text-[13px] mt-[20px]">{{ $t('inviteCenter.myPromoterLevel') }}<span
              class="color-[#FEFFFE]">{{ tuiages?.level || 0 }}</span></div>
          <div class="color-[#FFFFFF] text-[13px] mt-[20px]">{{ $t('inviteCenter.availableForCollection') }} <span
              class="color-[#FEF64A]">&nbsp;{{ tuiages?.commission }}</span></div>
          <div class="mt-[20px] color-[#5FB589] text-[13px]" style="line-height: 1.6;">{{
            $t('inviteCenter.commissionSettlementTime') }} <span class="color-[#FFFFFF]">{{ $t('inviteCenter.dailyTime')
            }}</span>
            {{ t('inviteCenter.daily') }}
          </div>
        </div>
        <div>

        </div>
      </div>
    </Border>
    <Border radius="13px" class="mt-[10px]">
      <div class="constsyel rounded-[13px]">
        <div class="text-[15px] color-[#FFFFFF]">{{ $t('inviteCenter.shareAndInvite') }}</div>
        <div class="flex items-center justify-between">
          <div class="text-[12px] color-[#FFFFFF]">{{ $t('inviteCenter.inviteFriendsToGet') }}
            {{ tuiages?.lastBoxConfig?.num }} {{ $t('inviteCenter.friendsToGet') }}</div>
          <div class="flex items-center color-[#EF841F] text-[20px]  font-bold">
            <div>{{ VITE_symbol }}</div>
            <div class="">{{ tuiages?.totalReward || 0 }}</div>
          </div>
        </div>
        <div class="mt-[10px]">
          <div class="flex items-center">
            <div class="text-center">
              <div class="color-[#60B289]">{{ tuiages?.boxConfigs?.[0]?.num }}p</div>
              <img :src="boxImages.weibao" alt="" class="w-[45px] h-[46px] mt-[5px]"
                v-if="tuiages?.boxConfigs?.[0]?.status == 0" />
              <img :src="boxImages.kaibao" alt="" class="w-[45px] h-[46px] mt-[5px]"
                v-if="tuiages?.boxConfigs?.[0]?.status == 1" @click="goDrawBoxReward(tuiages?.boxConfigs?.[0]?.id)" />
              <img :src="boxImages.yiabao" alt="" class="w-[45px] h-[46px] mt-[5px]"
                v-if="tuiages?.boxConfigs?.[0]?.status == 2" />
              <div class="color-[#FFEB5A] text-[12px] rounded-[4px] mt-[4px] overflow-hidden whitespace-nowrap" :class="{
                '!text-[#8E98A5]': tuiages?.boxConfigs?.[0]?.status == 2,
                borderstyle:
                  tuiages?.boxConfigs?.[0]?.status == 0 || tuiages?.boxConfigs?.[0]?.status == 1
              }">
                {{ VITE_symbol }} {{ tuiages?.boxConfigs?.[0]?.reward || 0 }}
              </div>
            </div>
            <template v-for="(box, index) in (tuiages?.boxConfigs?.slice(1)).slice(0, 3)" :key="index">
              <div class="w-[60px] bg-[#FFCC00] h-[2px] ml-[-5px]"></div>
              <div class="text-center ml-[-5px]">
                <div class="color-[#60B289]">{{ box?.num }}p</div>
                <img :src="boxImages.weibao" alt="" class="w-[45px] h-[46px] mt-[5px]" v-if="box?.status == 0" />
                <img :src="boxImages.kaibao" alt="" class="w-[45px] h-[46px] mt-[5px]" v-if="box?.status == 1"
                  @click="goDrawBoxReward(box?.id)" />
                <img :src="boxImages.yiabao" alt="" class="w-[45px] h-[46px] mt-[5px]" v-if="box?.status == 2" />
                <div
                  class="text-[#FFEB5A] text-[12px] rounded-[5px] mt-[4px] px-[1px] py-[2px] overflow-hidden whitespace-nowrap"
                  :class="{
                    '!text-[#8E98A5]': box?.status == 2,
                    borderstyle: box?.status == 0 || box?.status == 1
                  }">
                  {{ VITE_symbol }} {{ box?.reward || 0 }}
                </div>
              </div>
            </template>
            <img @click="goTreasure" :src="boxImages.end" alt="" class="w-[26px] h-[26px] ml-[10px]" />
          </div>
        </div>
      </div>
    </Border>
    <Border radius="13px" class="mt-[10px]">
      <div class=" sharestyle relative rounded-[13px]">
        <div class="absolute top-0 right-0 w-[76%] z-1">
          <img :src="getAssetsFile('home/qrCodeBg.png')" alt="" class="w-full h-auto">
        </div>
        <div class="relative z-2">
          <div class="text-[22px] color-[#FFFFFF] font-bold">
            <!-- Compartilhar Informação -->
            {{ $t('inviteCenter.referenceInfo') }}
          </div>
          <!-- <div class="h-[0.5px] w-full bg-[#339771] mt-[15px]"></div> -->
          <div class="flex mt-[10px] bg-[#166F5D] rounded-[5px] ">
            <div class="CodigoQrCard w-2.4/10 p-[8px] flex items-center">
              <div class="qrcode-box w-full">
                <QrcodeVue :value="url" :size="qrSize" />
              </div>
              <div class="qrcode-footer" @click="handleDownloadImage">{{ $t('inviteCenter.save') }}</div>
            </div>
            <div class="ml-[15px] flex-1 pr-[5px]">
              <!-- <div class="text-[10px] color-[#FFFFFF]">{{ $t('inviteCenter.myLink') }}</div> -->
              <div class="mt-[10px] lianse relative">
                <div class="text-[12px] two-line-ellipsis">{{ shareLink }}</div>
                <!-- <div class="flex justify-between">
              <div></div>
              <img :src="getAssetsFile('home/share@2x.png')" alt="" class="w-[16px] h-[13px] cursor-pointer"
                style="object-fit: contain;" @click="handleShare" />
            </div> -->
                <div class="flex justify-between ">
                  <div></div>
                  <Button type="medium" class="!w-[80px] !h-[26px]" @click="handleCopy">
                    <div class="flex items-center justify-center text-[9px]">
                      <img :src="getAssetsFile('home/copyed.png')" alt=""
                        class="w-[12px] h-[12px] cursor-pointer mr-[5px]" style="object-fit: contain;">
                      {{ $t('inviteCenter.copy') }}
                    </div>
                  </Button>
                </div>
              </div>
            </div>
          </div>
          <div class="flex items-center mt-[16px]  gap-[10px] justify-between">

            <div class="flex items-center w-full">
              <div id="my-inline-buttons" class="w-full" style="z-index:2"></div>
            </div>
            <div class="flex items-center flex-shrink-0">
              <div class="mr-[9px] w-[1px] h-[39px] bg-[#4CAE83]">

              </div>
              <Button type="next" class="!w-[38px] !h-[38px] !m-0" @click="handleShare">
                <!-- <img :src="getAssetsFile('home/next.png')" alt="" class="w-[12px] h-[12px] cursor-pointer"
                  style="object-fit: contain;"> -->
              </Button>
            </div>
          </div>
        </div>

      </div>
    </Border>
    <Border radius="13px" class="mt-[10px]">
      <div class="constsyel rounded-[13px]">
        <div class="flex justify-between">
          <div class="flex" @click="handleComissao">
            <div class="text-[12px] color-[#ffffff]">{{ $t('inviteCenter.commission') }}</div>


            <div class="flex items-center ml-[8px]">
              <!-- <div class="text-[12px] color-[#ffffff]">{{ $t('inviteCenter.more') }}</div> -->
              <img :src="getAssetsFile('home/arrow_left@2x1.png')" alt="" class="w-[6px] h-[9px] ">
            </div>


          </div>
          <div class="coletarBtn flex items-center justify-center" @click="handleHistorias">
            <img :src="getAssetsFile('home/historyButtonIcon.png')" alt="" class="w-[11px] h-[14px] mr-[6px]" />

            {{ $t('inviteCenter.history') }}
          </div>
        </div>
        <div class="bg-[#166F5D] rounded-[5px] mt-[10px] py-[12px] relative">
          <div class="absolute left-1/2 w-[1px] bg-[#57C898] h-[calc(100%-24px)]">
          </div>
          <div class="flex">
            <div class="flex justify-center items-center w-1/2">
              <div>
                <div class="text-[12px] text-white" style="">
                  <!-- Comissao Total -->
                  {{ $t('inviteCenter.totalCommission') }}
                </div>

              </div>
            </div>
            <div class="flex justify-center items-center w-1/2">
              <div>
                <div class="text-[12px] text-white">
                  {{ $t('inviteCenter.commissionClaimed') }}
                  <!-- Comissão Recebida -->
                </div>
              </div>
            </div>
          </div>
          <div class="flex">
            <div class="flex justify-center items-center w-1/2">
              <div>
                <div class="flex items-center mt-[10px] justify-center">
                  <div class="text-[24px] color-[#FFEB5A] font-bold"
                    style="text-shadow: 0px 2px 0px #FF815A;font-family: Poppins;">{{ VITE_symbol }} {{
                      tuiages?.profit + tuiages?.commission }}
                  </div>
                </div>
              </div>
            </div>

            <div class="flex justify-center items-center w-1/2">
              <div>
                <div class="flex items-center mt-[10px] justify-center">
                  <div class="text-[24px] color-[#FFEB5A] font-bold"
                    style="text-shadow: 0px 2px 0px #FF815A;font-family: Poppins;">{{ VITE_symbol }} {{
                      tuiages?.profit }}</div>
                </div>
              </div>
            </div>
          </div>

        </div>
        <div class="flex justify-between  mt-[11px]">
          <div class="flex items-center flex-wrap">
            <div class="flex items-center text-[12px] text-[#57C898]">
              <!-- Ultima Comissao Recebida: -->
              {{ $t('inviteCenter.lastCommissionClaim') }}
            </div>
            <div class="flex items-center ml-[5px]">
              <div class="text-[11px] color-[#FEF64A] font-bold">{{ VITE_symbol }} {{ tuiages?.lastDrawCommission }}
              </div>
            </div>
          </div>
          <div>
            <div class="historiasBtn flex items-center justify-center font-bold"
              :class="{ 'historiasBtnActive': canReceive, 'historiasBtnDisabled': !canReceive }"
              @click="canReceive ? handleReceive() : null">
              {{ $t('inviteCenter.receive') }}
            </div>
          </div>
        </div>
      </div>
    </Border>

    <Border radius="13px" class="mt-[10px]">
      <div class="constsyel rounded-[13px]">
        <div class="flex justify-between">
          <div class="w-4/10 text-[12px] color-[#60B289]">
            total de subordinados
            <!-- {{ $t('inviteCenter.totalSubordinateMembers') }} -->
          </div>
          <div class="w-3/10 flex items-center justify-end">
            <div class="text-[12px] color-[#ffffff]"> {{ tuiages?.promoterNum }} {{ $t('inviteCenter.num') }}</div>
            <!-- <img :src="getAssetsFile('home/arrow_left@2x1.png')" alt="" class="w-[6px] h-[9px] ml-[10px]"> -->
          </div>
        </div>
        <div class="h-[1px] bg-[#339771] w-full mt-[8px]"></div>
        <div class="flex justify-between mt-[11px]">
          <div class="w-4/10 text-[12px] color-[#60B289]">
            <!-- contribuição de subordinado direto -->
            {{ $t('inviteCenter.directSubordinateContribution') }}
          </div>
          <div class="w-3/10 text-[12px] color-[#FFFFFF] cwitems">{{ tuiages?.commissionInfo[0]?.userNum }} {{
            $t('inviteCenter.num')
          }}</div>
          <div class="w-3/10 flex items-center justify-end commission-amount">
            <div class="w-[12px] h-[13px]  flex-shrink-0"></div>
            <div class="text-[12px] color-[#FEF64A] min-w-0 flex-shrink-0">{{
              formatCommission(tuiages?.commissionInfo[0]?.totalCommission) }}</div>
          </div>
        </div>
        <div class="h-[1px] bg-[#339771] w-full mt-[8px]"></div>
        <div class="flex justify-between mt-[11px]">
          <div class="w-4/10 text-[12px] color-[#60B289]">
            {{ $t('inviteCenter.level2Subordinates') }}
            <!-- {{ $t('inviteCenter.level2Subordinates') }} -->
          </div>
          <div class="w-3/10 text-[12px] color-[#FFFFFF] cwitems tsie">{{ tuiages?.commissionInfo[1]?.userNum }} {{
            $t('inviteCenter.num') }}</div>
          <div class="w-3/10 flex items-center justify-end commission-amount">
            <img v-if="tuiages?.level < 2" :src="getAssetsFile('activity/tucengse.png')" alt=""
              class="w-[12px] h-[13px]  flex-shrink-0 mr-[10px]">
            <div v-else class="w-[12px] h-[13px] flex-shrink-0"></div>
            <div class="text-[12px] color-[#FEF64A] min-w-0 flex-shrink-0">{{
              formatCommission(tuiages?.commissionInfo[1]?.totalCommission) }}</div>
          </div>
        </div>
        <div class="h-[1px] bg-[#339771] w-full mt-[8px]"></div>
        <div class="flex justify-between mt-[11px]">
          <div class="w-4/10 text-[12px] color-[#60B289]">
            {{ $t('inviteCenter.level3Subordinates') }}
            <!-- {{ $t('inviteCenter.level3Subordinates') }} -->
          </div>
          <div class="w-3/10 text-[12px] color-[#FFFFFF] cwitems tsie">{{ tuiages?.commissionInfo[2]?.userNum }} {{
            $t('inviteCenter.num') }}</div>
          <div class="w-3/10 flex items-center justify-end commission-amount">
            <img v-if="tuiages?.level < 3" :src="getAssetsFile('activity/tucengse.png')" alt=""
              class="w-[12px] h-[13px]  flex-shrink-0 mr-[10px]">
            <div v-else class="w-[12px] h-[13px] flex-shrink-0"></div>
            <div class="text-[12px] color-[#FEF64A] min-w-0 flex-shrink-0">{{
              formatCommission(tuiages?.commissionInfo[2]?.totalCommission) }}</div>
          </div>
        </div>
        <div class="h-[1px] bg-[#339771] w-full mt-[8px]"></div>
        <div class="flex justify-between mt-[11px]">
          <div class="w-4/10 text-[12px] color-[#60B289]">{{ $t('inviteCenter.level4Subordinates') }}</div>
          <div class="w-3/10 text-[12px] color-[#FFFFFF] cwitems tsie">{{ tuiages?.commissionInfo[3]?.userNum }} {{
            $t('inviteCenter.num') }}</div>
          <div class="w-3/10 flex items-center justify-end commission-amount">
            <img v-if="tuiages?.level < 4" :src="getAssetsFile('activity/tucengse.png')" alt=""
              class="w-[12px] h-[13px] flex-shrink-0 mr-[10px]">
            <div v-else class="w-[12px] h-[13px]  flex-shrink-0"></div>
            <div class="text-[12px] color-[#FEF64A] min-w-0 flex-shrink-0">{{
              formatCommission(tuiages?.commissionInfo[3]?.totalCommission) }}</div>
          </div>
        </div>
        <div class="h-[1px] bg-[#339771] w-full mt-[8px]"></div>
        <div class="flex justify-between mt-[11px]">
          <div class="w-4/10 text-[12px] color-[#60B289]">{{ $t('inviteCenter.level5Subordinates') }}</div>
          <div class="w-3/10 text-[12px] color-[#FFFFFF] cwitems tsie">{{ tuiages?.commissionInfo[4]?.userNum }} {{
            $t('inviteCenter.num') }}</div>
          <div class="w-3/10 flex items-center justify-end commission-amount">
            <img v-if="tuiages?.level < 5" :src="getAssetsFile('activity/tucengse.png')" alt=""
              class="w-[12px] h-[13px]  flex-shrink-0 mr-[10px]">
            <div v-else class="w-[12px] h-[13px] flex-shrink-0"></div>
            <div class="text-[11px] color-[#FEF64A] min-w-0  max-w-[100px]">{{
              formatCommission(tuiages?.commissionInfo[4]?.totalCommission) }}</div>
          </div>
        </div>
        <div class="h-[.5px] bg-[#339771] w-full mt-[8px]"></div>
        <div class="text-[9px] color-[#5FB589] mt-[10px]">
          <div>{{ $t('inviteCenter.note') }}</div>
          <div class="mt-[7px]">{{ $t('inviteCenter.commissionSettlementNote') }} <span class="color-[#60B289]">{{
            $t('inviteCenter.settlementTime') }}</span></div>
          <div class="mt-[7px]">
            {{ $t('inviteCenter.unlockedCommissionNote') }}</div>
        </div>
        <div class="color-[#4EEF72] text-[9px] mt-[10px] underline" @click="handleHowToUnlock">{{
          $t('inviteCenter.howToUnlock') }}</div>
      </div>
    </Border>


    <!-- 在模板最后添加 RewardDialog 组件 -->
    <RewardDialog v-model:show="showRewardDialog" :amount="rewardAmount" @confirm="handleRewardConfirm" />
  </div>

</template>

<script setup lang="ts">
import { Border } from '@/components/Border'
import { Button } from '@/components/Button'
import QrcodeVue from 'qrcode.vue'
import { ref, onMounted, onUnmounted, computed } from 'vue'
import { useRouter } from 'vue-router'
import { getAssetsFile } from '@/utils/pub-use'
import { useClipboard } from '@vueuse/core'
import { useUserStore } from '@/stores/modules/user'
import * as GameApi from '@/api/game'
import RewardDialog from '@/components/RewardDialog.vue' // 导入 RewardDialog 组件
import useUIStore from '@/stores/modules/ui'
import { useI18n } from 'vue-i18n'
const VITE_symbol = import.meta.env.VITE_SYMBOL
const { t } = useI18n()

const userStore = useUserStore()
const uiStore = useUIStore()
const userInfo = computed(() => userStore.userInfo)
const router = useRouter()
const url = computed(() => {
  const baseUrl = `${window.location.origin}?pid=${userInfo.value?.activeCode}`
  const jumpType = tuiages.value?.jumpUrlType || 1
  return `${baseUrl}&jumpUrlType=${jumpType}`
})
const qrSize = ref(60)
import { numberFormat } from "@/utils/formatter";
const tuiages = ref<any>({
  commissionInfo: [], // 初始化为空数组
  boxConfigs: [], // 初始化为空数组
  commission: 0,
  profit: 0,
  promoterNum: 0,
  jumpUrlType: 1 // 添加默认值
})
const { copy: copyToClipboard } = useClipboard()
// 下面代码需要根据玩家的实际情况修改
const shareLink = computed(() => {
  const baseUrl = `${window.location.origin}?pid=${userInfo.value?.activeCode}`
  const jumpType = tuiages.value?.jumpUrlType || 1
  return `${baseUrl}&jumpUrlType=${jumpType}`
})
// const shareLink = ref(`${window.location.origin}?shareCode=` + userStore.user.activeCode)
const shareContent = reactive({
  url: computed(() => shareLink.value), // 使用 computed 包装
  title: `🎉 Join bluewhale and get ${VITE_symbol}1000 bonus! `,
  description: `Enter the welcome gift code: ROMAIN, Each user can receive a bonus of up to ${VITE_symbol}1000 from the gift code. Login link: Referrer's invitation link. Go to [Mine] - [Gift Code] and enter the gift code to claim your reward`
})

const ursl = ref(getAssetsFile('home/arrow_left@2x1.png'))
// 定义图片常量
const boxImages = {
  weibao: getAssetsFile('home/weibao.png'),
  kaibao: getAssetsFile('home/kaibao.png'),
  yiabao: getAssetsFile('home/yiabao.png'),
  end: getAssetsFile('home/21321.png')
}

// 分离数据获取和尺寸更新逻辑
function fetchPromoterInfo() {
  GameApi.userpromoterInfo().then(res => {
    if (res && res.data) {
      tuiages.value = res.data

      // 确保 commissionInfo 存在
      if (tuiages.value.commissionInfo && Array.isArray(tuiages.value.commissionInfo)) {
        tuiages.value.commisstotal = tuiages.value.commissionInfo.reduce((total: number, item: any) => {
          return total + (item.userNum || 0)
        }, 0)

        tuiages.value.commissqita = tuiages.value.commissionInfo.reduce((total: number, item: any, index: number) => {
          return index === 0 ? total : total + (item.userNum || 0)
        }, 0)
      }

      // 确保 jumpUrlType 有默认值
      if (!tuiages.value.jumpUrlType) {
        tuiages.value.jumpUrlType = 1
      }
    }
  }).catch(error => {
    console.error('获取推广信息失败:', error)
    // 保持默认值
  })
}

// 只更新二维码尺寸，不调用API
function updateQrSize() {
  qrSize.value = window.innerWidth <= 600 ? 60 : 60
}
const VITE_IMG_URL = import.meta.env.VITE_IMG_URL
onMounted(() => {
  // 初始化时获取数据
  fetchPromoterInfo()
  // 初始化二维码尺寸
  updateQrSize()
  // 只监听resize事件来更新尺寸，不调用API
  window.addEventListener('resize', updateQrSize)

  // 延迟初始化 ShareThis，确保 DOM 完全加载
  setTimeout(() => {
    initShareThis()
  }, 500)
})

// 初始化 ShareThis 的函数
const initShareThis = () => {
  if ((window as any).__sharethis__) {
    // 先清除可能存在的旧内容
    const container = document.getElementById('my-inline-buttons')
    if (container) {
      container.innerHTML = ''
    }

    (window as any).__sharethis__.load('inline-share-buttons', {
      alignment: 'justified',
      id: 'my-inline-buttons',
      enabled: true,
      font_size: 8,
      padding: 10,
      radius: 100,
      networks: ['facebook', 'twitter', 'whatsapp', 'telegram'],
      size: 38,
      show_mobile_buttons: true,
      spacing: 10,
      url: shareContent.url, // custom url
      title: shareContent.title,
      language: 'en',
      image: '', // useful for pinterest sharing buttons
      description: shareContent.description,
      username: '' // custom @username for twitter sharing
    })
  }
}
const handleHowToUnlock = () => {
  // 跳转到"代理奖金率"标签页
  emit('switchTab', 'bonus')
}
// 监听分享按钮是否消失的函数
const checkShareButtons = () => {
  const container = document.getElementById('my-inline-buttons')
  if (container && container.children.length === 0) {
    console.log('检测到分享按钮消失，重新初始化...')
    initShareThis()
  }
}

// 添加滚动监听器，在滚动时检查分享按钮
const handleScroll = () => {
  checkShareButtons()
}

onMounted(() => {
  // 初始化时获取数据
  fetchPromoterInfo()
  // 初始化二维码尺寸
  updateQrSize()
  // 只监听resize事件来更新尺寸，不调用API
  window.addEventListener('resize', updateQrSize)
  // 添加滚动监听器
  window.addEventListener('scroll', handleScroll, { passive: true })

  // 延迟初始化 ShareThis，确保 DOM 完全加载
  setTimeout(() => {
    initShareThis()
  }, 500)
})

onUnmounted(() => {
  window.removeEventListener('resize', updateQrSize)
  window.removeEventListener('scroll', handleScroll)
})

function handleShare() {
  if (navigator.share) {
    // 使用原生分享API（移动端）
    navigator.share({
      title: shareContent.title,
      text: shareContent.description,
      url: shareLink.value,
    }).catch((err) => {
      console.error('分享失败:', err)
      // 如果原生分享失败，回退到复制链接
      handleCopy()
    })
  } else {
    // 桌面端或原生分享不可用时，复制链接到剪贴板
    handleCopy()
  }
}
// 定义emit
const emit = defineEmits(['switchTab'])

function handleComissao() {
  // 触发事件，让父组件切换到Commission标签
  // 根据标签页的type来找到对应的索引，Commission对应type=4
  emit('switchTab', 'commission') // 传递标签类型而不是索引
}
function handleDesempenho() {
  // 触发事件，让父组件切换到Commission标签
  // 根据标签页的type来找到对应的索引，Commission对应type=4
  emit('switchTab', 'commission') // 传递标签类型而不是索引
}
function handleCopy() {
  copyToClipboard(shareLink.value)
    ; (window as any).$toast(t('inviteCenter.copySuccess'))
}
function handleHistorias() {
  router.push('relatorios')
}

// 计算是否可以领取
const canReceive = computed(() => {
  return tuiages.value?.commission > 0 || tuiages.value?.boundCommission > 0
})

// 添加领取处理函数
async function handleReceive() {
  if (canReceive.value) {
    try {
      const res = await GameApi.claimCommission()
      if (res.code == 200 || res.code == 0) {
        // 显示奖励弹窗，传递领取的金额
        rewardAmount.value = res.data
        showRewardDialog.value = true

        // 注意：这里不立即刷新数据，等弹窗确认后再刷新
        // updateQrSize() // 注释掉这行，等弹窗确认后再刷新
      } else {
        ; (window as any).$toast(t('inviteCenter.error'))
      }
    } catch (error) {
      ; (window as any).$toast(t('inviteCenter.error'))
    }
  }
}
const datalsit = ref({})
// 添加弹窗相关状态
const showRewardDialog = ref(false)
const rewardAmount = ref<any>({})

const goDrawBoxReward = async (id) => {
  try {
    const res = await GameApi.drawBoxReward(id)

    if (res && res.data) {
      // 显示奖励弹窗
      rewardAmount.value = res.data
      showRewardDialog.value = true

      // 注意：这里不立即刷新数据，等弹窗确认后再刷新
    } else {
      (window as any).$toast(t('inviteCenter.claimFailed'))
    }
  } catch (error) {
    (window as any).$toast(t('inviteCenter.error'))
  }
}

// 处理奖励确认
const handleRewardConfirm = async () => {
  // 弹窗关闭后的处理逻辑
  console.log('奖励已确认')

  // 等待一下确保API处理完成
  await new Promise(resolve => setTimeout(resolve, 500))

  // 刷新推广数据，这会更新宝箱状态
  await fetchPromoterInfo()
}

// 添加下载图片功能
const handleDownloadImage = async () => {
  try {
    // 从 store 获取推广配置
    const config = await uiStore.getPromoterConfig()
    console.log(config, '及哦嗲减掉五级地哦啊王继东i')
    if (config?.codeImg && Array.isArray(config.codeImg) && config.codeImg.length > 0) {
      // 随机选择一个图片
      const randomIndex = Math.floor(Math.random() * config.codeImg.length)
      const imagePath = config.codeImg[randomIndex]

      // 拼接完整的图片URL
      const imageUrl = `${VITE_IMG_URL}${imagePath}`

      // 创建下载链接
      const link = document.createElement('a')
      link.href = imageUrl
      link.download = `qrcode_${Date.now()}.png` // 设置下载文件名
      link.target = '_blank' // 在新窗口打开，避免在当前页面打开
      link.rel = 'noopener noreferrer' // 安全属性

      // 添加到DOM并触发点击
      document.body.appendChild(link)
      link.click()

      // 清理DOM
      document.body.removeChild(link)

        // 显示成功提示
        ; (window as any).$toast(t('inviteCenter.success'))
    } else {
      ; (window as any).$toast(t('inviteCenter.downloadFailed'))
    }
  } catch (error) {
    console.error('下载图片失败:', error)
      ; (window as any).$toast(t('inviteCenter.downloadFailed'))
  }
}

const goTreasure = async () => {
  router.push({ name: 'IndiqueAmigos' })
}

// 添加格式化函数
const formatCommission = (value: number | undefined): string => {
  if (value === undefined || value === null) return '0,00'
  return numberFormat(value, { minDecimals: 2 })
}
</script>
<style lang="scss" scoped>
.two-line-ellipsis {
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
  word-break: break-all;
  text-align: left;
  line-height: 1.4;
  /* 推荐行高自然值 */
  height: auto !important;
  /* 防止外部高度影响 */
  padding-top: 0 !important;
  /* 防止外部padding影响 */
}

.textstyle {
  font-size: 11px;
  /* 减小字体 */
  color: #5FB589;
  min-width: 140px;
  /* 设置最小宽度保持对齐 */
  max-width: 160px;
  /* 设置最大宽度 */
  flex-shrink: 0;
  line-height: 1.2;
  /* 减小行高 */
  word-wrap: break-word;
  /* 允许长单词换行 */
  overflow-wrap: break-word;
  /* 现代浏览器的换行属性 */
}

.cwitems {
  min-width: 70px;
  /* 增加最小宽度保持对齐 */
  flex-shrink: 0;
  text-align: center;
  /* 居中对齐 */
}

.commission-amount {
  min-width: 90px;
  /* 增加最小宽度保持对齐 */
  justify-content: flex-end;
  flex-shrink: 0;
}

.tsie {
  margin-left: 20px;
  /* 减小左边距 */
}

@media (max-width: 749px) {
  .constsyel {
    min-width: 300px;
    /* 移动端稍微减小最小宽度 */
  }

  .textstyle {
    font-size: 10px;
    /* 移动端更小字体 */
    min-width: 120px;
    /* 移动端保持最小宽度 */
    max-width: 140px;
    word-wrap: break-word;
    /* 移动端也允许换行 */
    overflow-wrap: break-word;
  }

  .cwitems {
    min-width: 60px;
    /* 移动端保持最小宽度 */
  }

  .commission-amount {
    min-width: 80px;
    /* 移动端保持最小宽度 */
  }

  .tsie {
    margin-left: 15px;
  }
}

/* 添加容器宽度限制 */
.constsyel {
  background: #104939;


  padding: 12px 8px 10px 8px;

  min-width: 320px;
  /* 设置最小宽度保持对齐 */
  max-width: 100%;
  /* 确保不超出父容器 */
  overflow-x: auto;
  /* 允许水平滚动 */
}

/* 优化flex布局 */
// .constsyel .flex {
//   gap: 8px;
//   /* 添加间距 */
//   min-width: 0;
//   /* 防止flex项目溢出 */
// }

/* 确保三列布局稳定 */
.constsyel .flex.justify-between {
  display: flex;
  justify-content: space-between;
  align-items: center;
  min-width: 280px;
  /* 确保有足够空间显示三列内容 */
}

/* 确保数字不会换行 */
.commission-amount .text-[\11px] {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  /* 如果数字太长，显示省略号 */
}

.conviteClass {

  background: #104939;

  display: flex;
  justify-content: space-between;
  padding: 15px 9px 6px 9px;
  border-bottom: 1px solid #009F76;
  position: relative;

  &::before {
    content: '';
    position: absolute;
    top: -29.5%;
    left: 47%;
    width: 100%;
    height: 100%;
    background: getPath('home/conviteClass.png') no-repeat;
    background-size: 56% auto;
  }

}

.coletarBtn {
  width: 72px;
  height: 28px;
  background: #166F5D;
  border: 1px solid #4CAE83;
  border-radius: 4px;
  color: #FEFEFE;
  font-weight: bold;
  font-size: 9px;

}

.historiasBtn {
  width: 78px;
  height: 29px;


  background: #008E71;
  box-shadow: 1px 1px 2px 0px rgba(21, 76, 55, 0.32);
  border-radius: 4px;
  color: #86AE89;
  font-weight: bold;
  font-size: 12px;
  margin-top: 10px;
}

.sharestyle {
  background: #104939;

  padding: 13px 8px 9px 8px;
}

.CodigoQrCard {
  position: relative;
  border-radius: 8px;
  overflow: hidden;
  background: transparent;
  display: flex;
  flex-direction: column;
  align-items: center;
  // height: 97px;
  box-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0.04);

  &::after {
    position: absolute;
    right: 0;
    content: '';
    display: block;
    width: 1px;
    height: 100%;
    background: #4CAE83;
  }
}

.qrcode-box {
  background: #fff;
  padding: 5px;
  /* 原来12px，缩小 */
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
  display: flex;
  justify-content: center;
  align-items: center;
  // width: 100%;
  // height: 97px;
}

.qrcode-footer {
  width: 100%;
  background: #4CAE83;
  color: #fff;
  text-align: center;
  font-size: 10px;
  font-weight: 500;
  padding: 4px 0 3px 0;
  border-bottom-left-radius: 8px;
  border-bottom-right-radius: 8px;
  letter-spacing: 1px;
}

.lianse {
  // border: 1px solid #4CAE83;
  border-radius: 5px;
  // height: 80px;
  padding: 11px 8px;
  color: #4EEF72;
  font-size: 9px;

  &::after {}
}

.constsyel {
  background: #104939;


  padding: 12px 8px 10px 8px;

}

.CodigoQrCard,
.qrcode-box {
  // width: auto;
  // min-width: 70px;
  // max-width: 110px;
}

.historiasBtnActive {
  background: #008E71;
  color: #FEFEFE;
  cursor: pointer;
  box-shadow: 0 2px 4px rgba(76, 175, 80, 0.3);
  transition: all 0.3s ease;
}

.historiasBtnActive:hover {
  transform: translateY(-1px);
  box-shadow: 0 4px 8px rgba(76, 175, 80, 0.4);
}

.historiasBtnDisabled {
  background: #008E71;
  color: #86AE89;
  cursor: not-allowed;
  opacity: 0.6;
}
</style>
